import { combineReducers } from 'redux';

import {
  SET_ACTIVE_TAB,
  SET_APP_TYPE,
  SET_DESIGN_STANDARD,
  SET_COUNTRY,
  SET_PROFILE_TYPE,
  SET_LANGUAGE,
  SET_ORIENTATION,
  SET_MODE,

  SET_DISTANCE_UNIT,
  SET_WEIGHT_UNIT,
  SET_TEMPERATURE_UNIT,
  SET_STRENGTH_UNIT,
  SET_MOMENT_UNIT,
  SET_LOAD_UNIT,
  SET_AREA_UNIT,
  SET_APP_STATUS,
  SET_MAIN_STATE,
  SET_USER_PROFILE,
  RESET_ORIENTATION,
  SET_PROJECT_NAME,
  RESET_PROJECT_NAME,
  SET_DIMENSIONS_LABELS
} from './actions';
import TABS from '../App/tabs';

import options from '@reducers/options';
import selectors from '@reducers/selectors';
import camera from '@reducers/camera';
import webServices from '@reducers/web-services';
import dimension from './selectors/dimension';

import { standardList } from '../app.values';
import { AREA, DISTANCE, LOAD, MOMENT, STRENGTH, TEMPERATURE, WEIGHT } from '@reducers/units';
import { mergeDeep } from '@services/helper.service';
import { APP_STATES, PROJECT_VERSION } from '@config';
import AbstractGenerator from '@scene/misc/generator';

export const imperialUnits = {
  distance: DISTANCE.INCHES,
  area: AREA.SQUARE_INCHES,
  strength: STRENGTH.POUND_PER_SQUARE_INCH,
  load: LOAD.POUND_FORCE,
  moment: MOMENT.FOOT_POUND_FORCE,
  temperature: TEMPERATURE.FAHRENHEIT,
  weight: WEIGHT.POUND
};

export const metricUnits = {
  distance: DISTANCE.MILLIMETERS,
  area: AREA.SQUARE_MILLIMETERS,
  strength: STRENGTH.NEWTON_SQUARE_MILLIMETERS,
  load: LOAD.KILONEWTON,
  moment: MOMENT.KILONEWTON_METER,
  temperature: TEMPERATURE.CELSIUS,
  weight: WEIGHT.KILOGRAM
};

const initialState = {
  activeTab: TABS.OPTIONS,
  mode: '3D', // 3D; 2D; 2D_EDITOR
  prevMode: null,

  appType: null,
  orientation: AbstractGenerator.orientation.X,
  status: APP_STATES.NOT_INITIALIZED,

  localization: {
    country: null,
    designStandard: standardList['EU'],
    language: null,
    profileType: null
  },

  units: metricUnits,

  modelType: 1,

  userProfile: {
    companyName: '',
    userName: '',
    phoneNumber: '',
    emailAddress: '',
    websiteAddress: ''
  },
  projectName: 'your-project',

  projectVersion: PROJECT_VERSION,

  // extendTimeout: false,

  dimensions: {
    showLabels: false
  }
};

const main = (state = initialState, action) => {
  switch (action.type) {
    case SET_MAIN_STATE: {
      return action.state;
    }
    case SET_MODE: {
      state.prevMode = state.mode;
      state.mode = action.mode;

      return mergeDeep({}, state);
    }
    case SET_ACTIVE_TAB: {
      state.activeTab = action.tabId;

      return mergeDeep({}, state);
    }
    case SET_APP_TYPE: {
      state.appType = action.appType;

      return mergeDeep({}, state);
    }
    case SET_ORIENTATION: {
      state.orientation = action.orientation;

      return mergeDeep({}, state);
    }
    case SET_DESIGN_STANDARD: {
      state.localization.designStandard = action.designStandard;

      return mergeDeep({}, state);
    }
    case SET_COUNTRY: {
      state.localization.country = action.country;

      return mergeDeep({}, state);
    }
    case SET_PROFILE_TYPE: {
      // state.localization.profileType = action.profileType;

      return mergeDeep({}, state, {
        localization: {
          profileType: action.profileType
        }
      });
    }
    case SET_LANGUAGE: {
      state.localization.language = action.language;

      return mergeDeep({}, state);
    }

    case SET_DISTANCE_UNIT: {
      state.units.distance = action.value;

      return mergeDeep({}, state);
    }
    case SET_WEIGHT_UNIT: {
      state.units.weight = action.value;

      return mergeDeep({}, state);
    }
    case SET_TEMPERATURE_UNIT: {
      state.units.temperature = action.value;

      return mergeDeep({}, state);
    }
    case SET_STRENGTH_UNIT: {
      state.units.strength = action.value;

      return mergeDeep({}, state);
    }
    case SET_MOMENT_UNIT: {
      state.units.moment = action.value;

      return mergeDeep({}, state);
    }
    case SET_LOAD_UNIT: {
      state.units.load = action.value;

      return mergeDeep({}, state);
    }
    case SET_AREA_UNIT: {
      state.units.area = action.value;

      return mergeDeep({}, state);
    }
    case SET_APP_STATUS: {
      return mergeDeep({}, state, {
        status: action.value
      });
    }
    case SET_USER_PROFILE: {
      return mergeDeep({}, state, {
        userProfile: mergeDeep({}, state.userProfile, action.value)
      });
    }
    case RESET_ORIENTATION: {
      return mergeDeep({}, state, {
        orientation: action.value
      });
    }
    case SET_PROJECT_NAME: {
      return mergeDeep({}, state, {
        projectName: action.value
      });
    }
    case RESET_PROJECT_NAME: {
      return mergeDeep({}, state, {
        projectName: initialState.projectName
      });
    }
    // case SET_EXTEND_TIMEOUT: {
    //   return mergeDeep({}, state, {
    //     extendTimeout: action.value
    //   });
    // }
    case SET_DIMENSIONS_LABELS: {
      return mergeDeep({}, state, {
        dimensions: {
          showLabels: action.value
        }
      });
    }
    default: {
      return state;
    }
  }
};

export default combineReducers({
  main,
  options,
  selectors,
  camera,
  webServices,
  dimension
});



// WEBPACK FOOTER //
// ./src/reducers/index.js